/**
 * Represente les points de sortie (socket output) d'un noeud affichant une étape de workflow.
 */
export class StepOutput {
    /**
     * Code de la socket.
     */
    public code: number;

    /**
     * Libellé de la socket
     */
    public label: string;

    /**
     * Constructeur.
     * @param triggerId : Id du trigger.
     */
    constructor(public triggerId: number) {}
}
